import React from "react"
import useIsMobile from "@/shared/use_is_mobile"
import VenueInfoDesktop from "./desktop"
import VenueInfoMobile from "./mobile"
import type { VenueInfoProps } from "./types"

const VenueInfo: React.FC<VenueInfoProps> = (props) => {
  const isMobile = useIsMobile()
  return isMobile ? <VenueInfoMobile {...props} /> : <VenueInfoDesktop {...props} />
}

export default VenueInfo
